const cleanEnv = (value) => {
  if (value == null || value === '') return value;
  return String(value).trim().replace(/^["']|["']$/g, '').replace(/\/+$/, '');
};

export default {

  apiUrl: cleanEnv(process.env.REACT_APP_API_URL),
  mainPageUrl: process.env.REACT_APP_MAIN_PAGE_URL,
  userCheckApiUrl: cleanEnv(process.env.REACT_APP_USER_CHECK_URL),
  userAuthApiUrl: cleanEnv(process.env.REACT_APP_USER_AUTH_URL),
  appUrl: process.env.REACT_APP_APP_URL,
  googleCaptchaSiteKey: cleanEnv(
    process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY || process.env.REACT_APP_RECAPTCHA_SITE_KEY
  ),

  defaultProfileImageUrl: "/images/user.jpg",

  copright: "Her hakkı saklıdır. Atatürk Kültür, Dil ve Tarih Yüksek Kurumu",
  coprightYear: "2025",

  b_ayk_tr: {
    url: "https://b.ayk.tr/api/urls",
    service: "b.ayk.tr"
  },

  insts: ["TDK", "TTK", "ATAM", "AKM", "YK"],
  institutions: [
    {
      id: 1,
      inst: "TDK",
      instLongName: "Türk Dil Kurumu",
      instLong: "Türk Dil Kurumu'nun",
      messages: "",
      color: "warning"
    },
    {
      id: 2,
      inst: "TTK",
      instLongName: "Türk Tarih Kurumu",
      instLong: "Türk Tarih Kurumu'nun",
      messages: "",
      color: "info"
    },
    {
      id: 3,
      inst: "ATAM",
      instLongName: "Atatürk Araştırma Merkezi",
      instLong: "Atatürk Araştırma Merkezi'nin",
      messages: "",
      color: "secondary"
    },
    {
      id: 4,
      inst: "AKM",
      instLongName: "Atatürk Kültür Merkezi",
      instLong: "Atatürk Kültür Merkezi'nin",
      messages: "",
      color: "primary"
    },
    {
      id: 5,
      inst: "YK",
      instLongName: "Atatürk Kültür, Dil ve Tarih Yüksek Kurumu",
      instLong: "Atatürk Kültür, Dil ve Tarih Yüksek Kurumu'nun",
      messages: "",
      color: "error"
    },
  ],

  dashboardCarsInfo: [
    {
      id: 1,
      name: "attented",
      title: "Geçmiş Toplantılarınız",
      tooltipTitle: "Geçmiş toplantıları",

      color: "#FFF3E0",      // Daha soft, açık turuncu
      otherColor: "#F57C00"  // Daha canlı, parlak turuncu
    },

    {
      id: 3,
      name: "review",
      title: "Değerlendirmeye Açılmış Toplantılar",
      tooltipTitle: "Değerlendirmeye açılmış toplantıları",
      color: "#E5F3FD",
      otherColor: "#3F88C5"
    },
    {
      id: 4,
      name: "vote",
      title: "Oylamaya Açılmış Toplantılar",
      tooltipTitle: "Oylamaya açılmış toplantıları",
      color: "#E8ECE4",
      otherColor: "#5A8F57"
    },
    {
      id: 5,
      name: "video",
      title: "Videoya Açılmış Toplantılar",
      tooltipTitle: "Videoya açılmış toplantıları",
      color: "#FFF0F5",      // Daha soft, açık mor
      otherColor: "#c2185b"  // Daha canlı, doygun mor
    },
    {
      id: 6,
      name: "allFinish",
      title: "Tüm Tamamlanmış Toplantılar",
      tooltipTitle: "Tamamlanmış toplantıları",
      color: "#FFF3E0",      // Daha soft, açık turuncu
      otherColor: "#F57C00"  // Daha canlı, parlak turuncu
    },


    {
      id: 2,
      name: "ongoing",
      title: "Devam Eden Toplantılarınız",
      tooltipTitle: "Devam eden toplantılarızı",
      color: "#EDE7F6",
      otherColor: "#673AB7"
      // color: "#E3F2FD",       // Çok soft, açık honeydew yeşili
      // otherColor: "#42A5F5"   // Canlı, doygun yeşil
    },
    {
      id: 7,
      name: "allOngoing",
      title: "Tüm Devam Eden Toplantılar",
      tooltipTitle: "Devam eden toplantıları",
      color: "#EDE7F6",
      otherColor: "#673AB7"
      // color: "#E0F7FA",       // Soft pastel turkuaz
      // otherColor: "#00BCD4"   // Canlı turkuaz
    },
    {
      id: 8,
      name: "admin",
      title: "Oluşturduğunuz Toplantılar",
      tooltipTitle: "Oluşturduğunuz toplantıları",
      color: "#FBE9E7",       // Çok soft, açık şeftali tonu
      otherColor: "#FF7043"   // Canlı, doygun mercan
    }


  ],


  departments: [
    { id: 1, name: "AKM", longName: "Atatürk Kültür Merkezi" },
    { id: 2, name: "ATAM", longName: "Atatürk Araştırma Merkezi" },
    { id: 3, name: "AYK", longName: "Atatürk Araştırma Merkezi" },
    { id: 4, name: "TDK", longName: "Türk Dil Kurumu" },
    { id: 5, name: "TTK", longName: "Türk Tarih Kurumu" },
    { id: 6, name: "YK", longName: "Atatürk Kültür, Dil ve Tarih Yüksek Kurumu" },
    { id: 7, name: "BÇKDB", longName: "Bilimsel Çalışmalar Koordinasyon Dairesi Başkanlığı" },
    { id: 8, name: "HM", longName: "Hukuk Müşavirliği" },
    { id: 9, name: "IKDHB", longName: "İnsan Kaynakları ve Destek Hizmetleri Dairesi Başkanlığı" },
    { id: 12, name: "IKDHM", longName: "İnsan Kaynakları ve Destek Hizmetleri Dairesi Müdürlüğü" },
    { id: 10, name: "SGDB", longName: "Strateji Geliştirme Dairesi Başkanlığı" },
    { id: 11, name: "İç Denetim Birimi", longName: "İç Denetim Birimi" },
  ],

  pageType: [

    {
      id: 1,
      page: "ykManagement"
    },
    {
      id: 2,
      page: "ykRead"

    },
    {
      id: 3,
      page: "kurulManagement"
    },
    {
      id: 4,
      page: "kurulRead"
    }

  ],



  meetingMemberRoles: [
    "Başkan",
    "Başkan Yrd",
    "Üye",
  ],

  meetingActing: [
    "Asaleten",
    "Vekaleten"
  ],

  managmentEmail: "esancak@ayk.gov.tr",
  developerEmail: "esancak@ayk.gov.tr",
  developerUserId: 386, // test bu gercegi degitir !!!!
  prodDeveloperUserId: 28001,


};

export const imageExtensions = ['.png', '.jpg', '.jpeg', '.gif', '.bmp', '.svg'];
export const ykUnitId = 11;
export const dshPreviousCardHeight = "350px";
export const dshPreviousCardScrollHeight = "320px";
export const dshPreviousCardFontSize = "10px";
export const baseFontSize = "12px";
export const meetingTitle = "9px";
export const iconFontSize = 18;

export const dshCardHeight = "480px";
export const dshCardScrollHeight = "400px";
export const dshCardScrollHeightV2 = "330px";

export const dshCardFontSize = "10px";



export const fontSettings = [
  {
    id: 'small',
    baseFontSize: "10px",
    smallTitleSize: '9px',
    avatarSize: 25,
    chipFontSize: "12px",
    titleSize: "13px",
    iconFontSize: "15px",
    smallFontSize: '8px',
    meetingTitle: '8px',
    itemSize: '9px',
    agendaFontSize: '10px',
    titleFontSize: '12px',
    attechmentTableFontSize: '9px',
    lineHeight: 1,
  },
  {
    id: 'medium',
    baseFontSize: "11px",
    smallTitleSize: '10px',
    avatarSize: 28,
    chipFontSize: "15px",
    titleSize: "15px",
    iconFontSize: "18px",
    smallFontSize: '10px',


    meetingTitle: '9px',
    itemSize: '10px',
    agendaFontSize: '12px',
    titleFontSize: '14px',
    attechmentTableFontSize: '10px',
    lineHeight: 1,
  },
  {
    id: 'large',
    baseFontSize: "13px",
    avatarSize: "36px",
    chipFontSize: "18px",
    iconFontSize: "21px",
    meetingTitle: '11px',
    smallFontSize: '12px',


    itemSize: '12px',
    agendaFontSize: '14px',
    titleFontSize: '16px',
    attechmentTableFontSize: '12px',
    titleSize: "17px",
  }
]
//E7EBF1
export const departmentCardColor = '#E7EBF1';  // Çok açık gri, neredeyse beyaz
export const departmentCardTextColor = '#333333';         // Hafif buz mavisi, ferahlatıcı ve minimal

export const agendaSubjectCardColor = '#F9FAFB';  // Çok açık gri, neredeyse beyaz
export const agendaCardColor = '#EFF6FF';         // Hafif buz mavisi, ferahlatıcı ve minimal
export const agendaCardTitleColor = '#DBEAFE';      // Yumuşak mavi tonu, nazik vurgu
export const agendaCardTitleFontColor = '#334155';  // Koyu gri-mavi, yumuşak ama net okunabilirlik
export const subjectCardTextColor = '#1E293B';
export const agendaCardTextColor = '#1E293B';
export const meetingTitleTextColor = '#1E293B';

export const dshUyeCardHeight = "400px";
export const dshUyeCardScrollHeight = "380px";


export const allRoles = [
  {
    roleId: 373,
    name: "Kurum Yöneticisi",
    custom: false,
    instSelect: 1
  },
  {
    roleId: 368,
    name: "Kurum Yöneticisi Tam Okuma",
    custom: false,
    instSelect: 1
  },
  {
    roleId: 369,
    name: "Kurum Toplantı Yöneticisi",
    custom: false,
    instSelect: 1
  },
  {
    roleId: 370,
    name: "Yüksek Kurum Yöneticisi",
    custom: false,
    instSelect: 0
  },
  {
    roleId: 371,
    name: "Yüksek Kurum Yöneticisi Tam Okuma",
    custom: false,
    instSelect: 0
  },
  {
    roleId: 416,
    name: "Yönetim Kurulu Uygulanma Durumu Güncelleme Yetkisi",
    custom: false,
    instSelect: 0
  },
  {
    roleId: 417,
    name: "Kurul/Komisyon Uygulanma Durumu Güncelleme Yetkisi",
    custom: false,
    instSelect: 0
  }
  ,
  {
    roleId: 372,
    name: "Yüksek Kurum Toplantı Yöneticisi",
    custom: false,
    instSelect: 1
  },
  {
    roleId: 418,
    name: "Yönetim Kurulu Tam Okuma",
    custom: false,
    instSelect: 0
  }

]



export const fileTypes = [
  { name: "Bağlantı", isYK: false },
  { name: "Bilgi Notu", isYK: false },
  { name: "Bilim ve Uygulama Kolu Dosyası", isYK: false },
  { name: "Bilimsel Etkinlik Dosyası", isYK: false },
  { name: "Burs", isYK: true },
  { name: "Burs Dosyası", isYK: false },
  { name: "Diğer", isYK: true },
  { name: "İmzalı karar", isYK: false },
  { name: "İnceleyici raporu", isYK: false },
  { name: "Kitap", isYK: true },
  { name: "Kitap metni", isYK: true },
  { name: "Kitap metni eki", isYK: false },
  { name: "Kitap tanıtım yazısı", isYK: false },
  { name: "Madde Metni", isYK: false },
  { name: "Makale", isYK: true },
  { name: "Makale metni", isYK: false },
  { name: "Makale metni eki", isYK: false },
  { name: "Mali", isYK: true },
  { name: "Personel", isYK: true },
  { name: "Proje", isYK: true },
  { name: "Proje Dosyası", isYK: false },
  { name: "Protokol", isYK: true },
  { name: "Toplantı", isYK: true },
  { name: "Uzman ön inceleme raporu", isYK: false },
  { name: "Ücretsiz Yayın", isYK: true },
  { name: "Yayın Faaliyet Dosyası", isYK: false }
];


export const titleOrder = ["Prof.Dr.", "Doç.Dr.", "Doç.", "Dr."];
export const rolePriority = {
  "Başkan": 1,
  "Başkan Yrd": 2,
  "Üye": 3
};
export const dashboardCardHeight = "200px";
export const greenColor = "#3BD2A2"; // 3BD2A2 , 57BE4A
export const grayColor = "#A4A4A4";
export const redColor = "#e44a77"; // E73146, E96E92

export const primaryColor = "#7352C7"; // E73146, E96E92


export const voteResultType = [

  {
    id: 1,
    text: "Salt çoğunluk sağlanamadı.",
    decisionReportText: "görüşüldü ve oylama sonucu için yeterli çoğunluk sağlanamadı" // ????
  },
  {
    id: 2,
    text: "Salt çoğunluk sağlandı fakat kabul ve ret oyları eşittir",
    decisionReportText: "görüşüldü ve kabul ve ret oyları eşittir" //????

  },
  {
    id: 3,
    text: "Oy birliği ile kabul edilmiştir.",
    decisionReportText: "görüşüldü ve teklifin uygun olduğuna"
  },
  {
    id: 4,
    text: "Oy birliği ile reddedilmiştir.",
    decisionReportText: "görüşüldü ve teklifin uygun olmadığına"
  },
  {
    id: 5,
    text: "Oy çokluğu ile kabul edilmiştir.",
    decisionReportText: "görüşüldü ve teklifin uygun olduğuna"
  },
  {
    id: 6,
    text: "Oy çokluğu ile reddedilmiştir.",
    decisionReportText: "görüşüldü ve teklifin uygun olmadığına"
  }
]


export const periodicReportCutoffDate = new Date('2025-07-01');

export const testProjeEskgId = 114;
export const prodProjeEskgId = 114;

export const testYKToplantisiUnitId = 11;
export const prodYKToplantisiUnitId = 11;

